
// ======== Listing Page Revies Count Down Start 
document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".count");
    const ratingCounter = document.querySelector(".rating_count");
    let counted = false;

    const duration = 2000; // 2 seconds

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting && !counted){
                counted = true;

                // Count for top ratings
                counters.forEach(counter => {
                    const target = parseFloat(counter.getAttribute("data-target"));
                    const startTime = performance.now();

                    const updateCount = (currentTime) => {
                        const elapsed = currentTime - startTime;
                        let progress = Math.min(elapsed / duration, 1);
                        counter.innerText = (target * progress).toFixed(1);
                        if(progress < 1){
                            requestAnimationFrame(updateCount);
                        } else {
                            counter.innerText = target.toFixed(1);
                        }
                    }
                    requestAnimationFrame(updateCount);
                });

                // Count for main rating
                if(ratingCounter){
                    const target = parseFloat(ratingCounter.getAttribute("data-target"));
                    const startTime = performance.now();

                    const updateRating = (currentTime) => {
                        const elapsed = currentTime - startTime;
                        let progress = Math.min(elapsed / duration, 1);
                        ratingCounter.innerText = (target * progress).toFixed(2);
                        if(progress < 1){
                            requestAnimationFrame(updateRating);
                        } else {
                            ratingCounter.innerText = target.toFixed(2);
                        }
                    }
                    requestAnimationFrame(updateRating);
                }

            }
        });
    }, { threshold: 0.5 });

    const reviewsTitleSection = document.querySelector(".reviews_title_section");
    if (reviewsTitleSection) {
      observer.observe(reviewsTitleSection);
    }
});
// ======== Listing Page Revies Count Down End
// ======== Listing Page Hero Count Down Start 
document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".count");
    let counted = false; // একবারেই count হবে

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !counted) {
                counted = true;
                counters.forEach(counter => {
                    const format = counter.getAttribute("data-format");
                    const target = parseFloat(counter.getAttribute("data-target"));
                    
                    const updateCount = () => {
                        let currentText = counter.innerText;
                        let count = parseFloat(currentText.replace('%','').replace(/[^0-9.]/g, '')) || 0;
                        
                        if (format === "number") {
                            // Number format (e.g., 4.8, 700)
                            const increment = target / 50; // Smooth animation
                            
                            if (count < target) {
                                count = Math.min(count + increment, target);
                                // Format: show decimals for ratings < 10, whole numbers for larger values
                                if (target < 10) {
                                    counter.innerText = count.toFixed(1);
                                } else {
                                    counter.innerText = Math.floor(count);
                                }
                                setTimeout(updateCount, 20);
                            } else {
                                if (target < 10) {
                                    counter.innerText = target.toFixed(1);
                                } else {
                                    counter.innerText = Math.floor(target);
                                }
                            }
                        } else {
                            // Percentage format (legacy)
                            const increment = target / 100;
                            
                            if (count < target) {
                                counter.innerText = Math.ceil(count + increment) + "%";
                                setTimeout(updateCount, 20);
                            } else {
                                counter.innerText = target + "%";
                            }
                        }
                    }
                    updateCount();
                });
            }
        });
    }, { threshold: 0.5 });

    const heroLastGap = document.querySelector(".hero_last_gap");
    if (heroLastGap) {
      observer.observe(heroLastGap);
    }
});
// ======== Listing Page Hero Count Down End 

// Hero Popup Start
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("hero_popup_id");
  if (!btn) return;
  
  const popupWrap = document.querySelector(".hero_popup_wrap");
  const iconMenu = btn.querySelector(".icon-menu");
  const iconClose = btn.querySelector(".icon-close");

  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const isActive = popupWrap.classList.toggle("active");

    // JS handles icon switch
    if (isActive) {
      iconMenu.style.display = "none";
      iconClose.style.display = "block";
    } else {
      iconMenu.style.display = "block";
      iconClose.style.display = "none";
    }

    btn.setAttribute("aria-expanded", isActive);
  });

  // Click outside → close popup
  document.addEventListener("click", (e) => {
    if (!popupWrap.contains(e.target) && !btn.contains(e.target)) {
      popupWrap.classList.remove("active");
      iconMenu.style.display = "block";
      iconClose.style.display = "none";
      btn.setAttribute("aria-expanded", "false");
    }
  });
});

// ============== Form And Destil fix and useLayoutEffect(menu) Active Start ========
document.addEventListener("DOMContentLoaded", function () {

    const sections = document.querySelectorAll(
        "#overview, #spaces, #services, #access"
    );

    const menuLinks = document.querySelectorAll(".details_menu a");

    function onScroll() {
        let scrollPos = window.scrollY + 120;

        sections.forEach(section => {
            const top = section.offsetTop;
            const height = section.offsetHeight;
            const id = section.getAttribute("id");

            if (scrollPos >= top && scrollPos < top + height) {
                menuLinks.forEach(link => link.classList.remove("active"));
                document
                    .querySelector('.details_menu a[href="#' + id + '"]')
                    .classList.add("active");
            }
        });
    }

    window.addEventListener("scroll", onScroll);
}); 
// ============== Form And Destil fix and useLayoutEffect(menu) Active End ======== 

// Hero Popup End

document.addEventListener("DOMContentLoaded", () => {
    // Support multiple gallery tracks (for Content Gallery and Product Gallery sections)
    const tracks = document.querySelectorAll('.about_gallery_track');
    
    tracks.forEach(track => {
        if (!track) return;

        const slider = track.closest('.about_gallery_slider');
        if (!slider) return;

        const items = [...track.children];
        if (items.length === 0) return;

        // Clone items for seamless infinite auto-scroll
        items.forEach(item => {
            const clone = item.cloneNode(true);
            track.appendChild(clone);
        });

        const originalWidth = items.reduce((sum, item) => sum + item.offsetWidth, 0);
        if (originalWidth === 0) return;

        const scrollSpeedSetting = parseFloat(getComputedStyle(track).getPropertyValue('--gallery-scroll-speed')) || 40;
        const basePixelsPerSecond = 60;
        const pixelsPerSecond = Math.max(30, Math.min(120, (basePixelsPerSecond * 40) / scrollSpeedSetting));
        let speed = pixelsPerSecond / 60;
        let slowSpeed = speed * 0.625;
        let currentSpeed = speed;
        let targetSpeed = speed;
        let position = 0;
        let rafId = null;
        let isManual = false;

        // ── Switch from auto-scroll to native scroll mode ──────────────────────
        function enterManualMode() {
            if (isManual) return;
            isManual = true;

            cancelAnimationFrame(rafId);
            rafId = null;

            // Freeze current visual position as scroll offset
            const snapPosition = position % originalWidth;
            track.style.transform = 'none';
            track.style.willChange = 'auto';

            // Make the slider natively scrollable
            slider.style.overflowX = 'auto';
            slider.style.overflowY = 'hidden';
            slider.style.cursor = 'grab';
            slider.style.webkitOverflowScrolling = 'touch';
            slider.scrollLeft = snapPosition;

            // Remove hover speed listeners (no longer relevant)
            track.removeEventListener('mouseenter', onMouseEnter);
            track.removeEventListener('mouseleave', onMouseLeave);
        }

        // ── Auto-scroll animation loop ──────────────────────────────────────────
        function animate() {
            currentSpeed += (targetSpeed - currentSpeed) * 0.05;
            position = (position + currentSpeed) % originalWidth;
            track.style.transform = `translateX(-${position}px)`;
            rafId = requestAnimationFrame(animate);
        }

        function onMouseEnter() { targetSpeed = slowSpeed; }
        function onMouseLeave() { targetSpeed = speed; }

        track.addEventListener('mouseenter', onMouseEnter);
        track.addEventListener('mouseleave', onMouseLeave);
        rafId = requestAnimationFrame(animate);

        // ── Trigger manual mode on wheel scroll ─────────────────────────────────
        slider.addEventListener('wheel', () => enterManualMode(), { passive: true, once: true });

        // ── Trigger manual mode on touch drag (not tap) ─────────────────────────
        let touchStartX = 0;
        slider.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
        }, { passive: true });
        slider.addEventListener('touchmove', (e) => {
            if (Math.abs(e.touches[0].clientX - touchStartX) > 6) enterManualMode();
        }, { passive: true, once: true });

        // ── Drag-to-scroll with mouse (also stops animation) ────────────────────
        let isDragging = false;
        let dragStartX = 0;
        let dragStartScroll = 0;
        let hasDragged = false;

        slider.addEventListener('mousedown', (e) => {
            isDragging = true;
            hasDragged = false;
            dragStartX = e.clientX;
            dragStartScroll = isManual ? slider.scrollLeft : position;
            slider.style.cursor = 'grabbing';
            slider.style.userSelect = 'none';
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            const dx = e.clientX - dragStartX;
            if (Math.abs(dx) > 4) {
                enterManualMode();
                hasDragged = true;
                slider.scrollLeft = dragStartScroll - dx;
            }
        });

        document.addEventListener('mouseup', () => {
            if (!isDragging) return;
            isDragging = false;
            if (isManual) slider.style.cursor = 'grab';
            slider.style.userSelect = '';
        });

        // Prevent lightbox from firing if the user was dragging (not clicking)
        slider.addEventListener('click', (e) => {
            if (hasDragged) {
                e.stopPropagation();
                hasDragged = false;
            }
        }, true);
    });
});


// ===== Count Up on Scroll =====
document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll("#statisticsSection h5");
    const section = document.getElementById("statisticsSection");
    const duration = 600; // fast animation (was 3000ms), no need to count one by one

    function animateCounters(timestamp) {
        if (!animateCounters.startTime) animateCounters.startTime = timestamp;
        const elapsed = timestamp - animateCounters.startTime;
        // Ease-out: quick start, smooth finish
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 2);

        counters.forEach(counter => {
            const target = +counter.getAttribute("data-target");
            const display = counter.getAttribute("data-display");
            const current = Math.floor(eased * target);
            counter.innerText = display && progress >= 1 ? display : (target >= 1000 ? current.toLocaleString() : current);
        });

        if (progress < 1) {
            requestAnimationFrame(animateCounters);
        } else {
            counters.forEach(counter => {
                const display = counter.getAttribute("data-display");
                counter.innerText = display || counter.getAttribute("data-target");
            });
        }
    }

    // Intersection Observer to trigger when section center is visible
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                requestAnimationFrame(animateCounters);
                observer.disconnect(); // trigger only once
            }
        });
    }, {
        root: null,             // viewport
        threshold: 0.5          // 50% of section visible (roughly center)
    });

    if (section) {
      observer.observe(section);
    }
});

// ==== Logo Slider 
document.addEventListener("DOMContentLoaded", () => {
    // Support both ID formats: logoSlider and logoSlider-{section.id}
    const slider = document.getElementById("logoSlider") || document.querySelector('[id^="logoSlider"]');
    if (!slider) return;

    // Duplicate all logos once → Seamless infinite loop
    slider.innerHTML += slider.innerHTML;
});


// ==== Animation Effect 
document.addEventListener("DOMContentLoaded", () => {

  // ----------------------
  // SCROLL ANIMATION + TYPE EFFECT
  // ----------------------
  const TYPING_SPEED_MULTIPLIER = 0.65; // ~35% faster than current baseline

  function speedUpExistingTypedSpans(el) {
    // Pre-rendered headings already contain per-letter inline animation delays.
    // Normalize them globally so we can tune speed from one place.
    if (el.dataset.typingSpeedAdjusted === "true") return;
    const letterSpans = el.querySelectorAll("span[style*='animation-delay']");
    letterSpans.forEach((span) => {
      const rawDelay = span.style.animationDelay;
      const delaySeconds = parseFloat(rawDelay);
      if (!Number.isNaN(delaySeconds)) {
        span.style.animationDelay = `${delaySeconds * TYPING_SPEED_MULTIPLIER}s`;
      }
    });
    el.dataset.typingSpeedAdjusted = "true";
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const el = entry.target;

        // ---------- TYPING EFFECT ----------
        // ---------- TYPING EFFECT ----------
if (el.dataset.type === "true") {
  // Skip if element already has span children (already processed by Liquid template)
  if (el.querySelector('span')) {
    speedUpExistingTypedSpans(el);
    el.classList.add("show");
    return;
  }

  const text = el.textContent.trim();
  el.textContent = "";
  el.classList.add("show");

  const configuredSpeed = parseFloat(el.dataset.speed);
  const baseSpeed = !Number.isNaN(configuredSpeed) && configuredSpeed > 0 ? configuredSpeed : 0.05;
  const speed = baseSpeed * TYPING_SPEED_MULTIPLIER;

  // split text by words
  const words = text.split(" ");

  let letterIndex = 0;

  words.forEach((word, wIndex) => {

    // word wrapper (prevents word break)
    const wordSpan = document.createElement("span");
    wordSpan.className = "word";

    // split word into letters
    word.split("").forEach(char => {
      const span = document.createElement("span");
      span.textContent = char;
      span.style.animationDelay = `${letterIndex * speed}s`;
      wordSpan.appendChild(span);
      letterIndex++;
    });

    el.appendChild(wordSpan);

    // add space after word (except last)
    if (wIndex !== words.length - 1) {
      const space = document.createTextNode("\u00A0");
      el.appendChild(space);
      letterIndex++;
    }
  });
}

        // ---------- NORMAL SCROLL ANIMATION ----------
        else {

          const delay = el.dataset.delay || "0s";
          const duration = el.dataset.duration || "0.8s";

          el.style.transitionDelay = delay;
          el.style.transitionDuration = duration;

          el.classList.add("show");
        }

      }
    });
  }, { threshold: 0 });
  // NOTE: threshold was 0.4 (require 40% of the element visible before
  // revealing). That silently broke reveal-on-scroll for any element taller
  // than the viewport (e.g. a long FAQ accordion) since intersectionRatio
  // can never reach 40% for something ~2x+ the viewport height, so
  // entry.isIntersecting never became true and .show was never added,
  // leaving the whole block stuck at opacity 0. threshold: 0 reveals as
  // soon as any part of the element enters the viewport, which fixes tall
  // elements and is the standard, safe setting for scroll-reveal effects.

  // ----------------------
  // OBSERVE ELEMENTS
  // ----------------------
  const ANIMATE_SELECTOR =
    ".animate, .animate-text, .bottom_to_top, .zoom_bounce, .left_to_right, .right_to_left";

  const elements = document.querySelectorAll(ANIMATE_SELECTOR);

  elements.forEach(el => observer.observe(el));

  // ----------------------
  // FAIL-SAFE REVEAL
  // ----------------------
  // Every animated element starts at opacity: 0 and only becomes visible when
  // this IntersectionObserver adds .show. That makes the whole page depend on
  // the observer's first callback actually being delivered — and it is not
  // always. IntersectionObserver callbacks run as part of the rendering
  // lifecycle, so they are delayed or dropped entirely when the tab is
  // backgrounded or prerendered at load, restored from bfcache, or when the
  // main thread is busy during hydration. When that happens the reader gets a
  // blank page until they scroll, which is indistinguishable from a broken site.
  //
  // Two guards, both cheap:
  //   1. Reveal anything already in the viewport right now, synchronously, so
  //      above-the-fold content never waits on the observer at all.
  //   2. A timeout backstop that reveals anything still hidden in view, and a
  //      re-check when the tab becomes visible again.

  function revealIfInViewport() {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    document.querySelectorAll(ANIMATE_SELECTOR).forEach(el => {
      if (el.classList.contains("show")) return;

      const rect = el.getBoundingClientRect();
      const inView = rect.top < viewportHeight && rect.bottom > 0;
      if (!inView) return;

      if (el.dataset.type === "true" && !el.querySelector("span")) {
        // Leave un-split typing headings to the observer so the effect still
        // runs; only force the plain fade-ups.
        return;
      }

      el.classList.add("show");
    });
  }

  revealIfInViewport();
  window.setTimeout(revealIfInViewport, 1200);

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") revealIfInViewport();
  });

  window.addEventListener("pageshow", event => {
    if (event.persisted) revealIfInViewport();
  });

});



// ===== lazy Image 
document.addEventListener("DOMContentLoaded", function() {
    const lazyImages = document.querySelectorAll('img.lazy');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.add('loaded');
            observer.unobserve(img);
          }
        });
      }, { rootMargin: "0px 0px 100px 0px" });

      lazyImages.forEach(img => {
        if (img && img.nodeType === 1) { // Check if it's an Element
          observer.observe(img);
        }
      });
    } else {
      // fallback for old browsers
      lazyImages.forEach(img => {
        img.src = img.dataset.src;
        img.classList.add('loaded');
      });
    }
  });

// Accordion Image Change
document.addEventListener("DOMContentLoaded", function() {
  const imgBox = document.getElementById("dynamicImage");
  const accordionButtons = document.querySelectorAll("#serviceAccordion .accordion-button");
  const preloadedImages = new Map(); // Cache for preloaded images

  if (imgBox && accordionButtons.length > 0) {
    // Function to preload a single image on demand
    function preloadImage(imgUrl) {
      if (!imgUrl || preloadedImages.has(imgUrl)) {
        return Promise.resolve();
      }
      
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          preloadedImages.set(imgUrl, true);
          resolve();
        };
        img.onerror = reject;
        img.src = imgUrl;
      });
    }

    // Function to update image
    async function updateImage(imgUrl) {
      if (imgUrl && imgBox && imgBox.src !== imgUrl) {
        // Preload the image first (if not already loaded)
        await preloadImage(imgUrl);
        
        // Fade out
        imgBox.classList.add("fade-out");
        // Use requestAnimationFrame for smooth transition
        requestAnimationFrame(() => {
          // Update image
          imgBox.src = imgUrl;
          imgBox.removeAttribute("srcset");
          imgBox.removeAttribute("sizes");
          // Fade in on next frame
          requestAnimationFrame(() => {
            imgBox.classList.remove("fade-out");
          });
        });
      }
    }

    // Set initial image for the first open accordion
    const firstOpen = document.querySelector("#serviceAccordion .accordion-collapse.show");
    if (firstOpen) {
      const initialImg = firstOpen.getAttribute("data-img");
      if (initialImg) {
        updateImage(initialImg);
      }
    }

    // Listen for button clicks and hover (for preloading)
    accordionButtons.forEach(button => {
      // Preload on hover for instant switching
      button.addEventListener("mouseenter", function() {
        const targetId = this.getAttribute("data-bs-target");
        if (targetId) {
          const targetCollapse = document.querySelector(targetId);
          if (targetCollapse) {
            const imgUrl = targetCollapse.getAttribute("data-img");
            if (imgUrl) {
              preloadImage(imgUrl);
            }
          }
        }
      });

      // Update image on click
      button.addEventListener("click", function() {
        const targetId = this.getAttribute("data-bs-target");
        if (targetId) {
          const targetCollapse = document.querySelector(targetId);
          if (targetCollapse) {
            const newImg = targetCollapse.getAttribute("data-img");
            if (newImg) {
              updateImage(newImg);
            }
          }
        }
      });
    });

    // Listen for Bootstrap collapse events (dispatched by navbar-collapse.js)
    const accordions = document.querySelectorAll(".accordion-collapse");
    accordions.forEach(item => {
      // Listen for custom show.bs.collapse event
      item.addEventListener("show.bs.collapse", function () {
        const newImg = this.getAttribute("data-img");
        if (newImg) {
          updateImage(newImg);
        }
      });
    });
  }
});

// Back to Top Button
document.addEventListener("DOMContentLoaded", function() {
  const backToTopBtn = document.querySelector('.back_to_top');
  if (backToTopBtn) {
    backToTopBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '50px'
  });

  const introductionImg = document.querySelector("#introduction_img");
  if (introductionImg) {
    observer.observe(introductionImg);
  }

});

// Collection grid — "New" tag confetti: play once when scrolled into view
document.addEventListener("DOMContentLoaded", () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const newTags = document.querySelectorAll(".collection-grid-product-new-tag");
  if (!newTags.length) return;

  const burstClass = "collection-grid-product-new-tag--scroll-burst";
  const burstMs = 780;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const tag = entry.target;
        if (tag.dataset.confettiScrollPlayed === "1") return;
        tag.dataset.confettiScrollPlayed = "1";
        io.unobserve(tag);
        tag.classList.add(burstClass);
        window.setTimeout(() => {
          tag.classList.remove(burstClass);
        }, burstMs);
      });
    },
    { threshold: 0.32, rootMargin: "0px 0px -6% 0px" }
  );

  newTags.forEach((tag) => io.observe(tag));
});

// ======== Shop page Product Filter 
const tabs = document.querySelectorAll(".filter-tabs .nav-link");
  const items = document.querySelectorAll(".product-item");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {

      // active class
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const filter = tab.getAttribute("data-filter");

      items.forEach(item => {
        if (filter === "all" || item.dataset.category === filter) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });

    });
  });

  // ========== Single Product apge 
  // Img slide 
  const mainImg = document.querySelector('.single_product_view img');
const thumbnails = document.querySelectorAll('.single_product_img_slide img');

thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
        const newSrc = thumb.getAttribute('data-src');

        // fade out main image
        mainImg.classList.add('fade-out');

        // wait for fade out, then change src and fade in
        setTimeout(() => {
            mainImg.setAttribute('data-src', newSrc);
            mainImg.src = newSrc;
            mainImg.classList.remove('fade-out');
        }, 300);

        // remove active class from all thumbnails
        thumbnails.forEach(t => t.classList.remove('active'));

        // add active class to clicked thumbnail
        thumb.classList.add('active');
    });
});


// ===== Single Product Form 
document.addEventListener("click", function (e) {
    // Avoid double-processing when single-product.js already handled quantity clicks.
    if (e.defaultPrevented) return;

    // INCREASE
    const increaseBtn = e.target.closest("#increase_qty");
    if (increaseBtn) {
        const box = increaseBtn.closest(".count_number_for_product");
        if (!box) return;
        const qtySpan = box.querySelector("#quantity_value");
        if (!qtySpan) return;
        const form = increaseBtn.closest("form");
        const qtyInput = form ? form.querySelector("#product_quantity") : null;

        let qty = parseInt(qtySpan.textContent, 10) || 1;
        qty++;

        qtySpan.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
    }

    // DECREASE
    const decreaseBtn = e.target.closest("#decrease_qty");
    if (decreaseBtn) {
        const box = decreaseBtn.closest(".count_number_for_product");
        if (!box) return;
        const qtySpan = box.querySelector("#quantity_value");
        if (!qtySpan) return;
        const form = decreaseBtn.closest("form");
        const qtyInput = form ? form.querySelector("#product_quantity") : null;

        let qty = parseInt(qtySpan.textContent, 10) || 1;
        if (qty > 1) qty--;

        qtySpan.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
    }

});



// ============ Single Product Description 
document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll(".jholok_custom_accordion .jholok_accordion_item");

    items.forEach(item => {
        const header = item.querySelector(".jholok_accordion_header");

        header.addEventListener("click", () => {
            // Close any other open item
            items.forEach(i => {
                if (i !== item) {
                    i.classList.remove("open");
                }
            });

            // Toggle clicked item
            item.classList.toggle("open");
        });
    });
});

// ======== about page mision vision silder 

document.querySelectorAll('.single_product_view').forEach(box => {
            const img = box.querySelector('img');

            box.addEventListener('mousemove', (e) => {
                const rect = box.getBoundingClientRect();

                const x = ((e.clientX - rect.left) / rect.width) * 100;
                const y = ((e.clientY - rect.top) / rect.height) * 100;

                img.style.transformOrigin = `${x}% ${y}%`;
                img.style.transform = 'scale(1.8)';
            });

            box.addEventListener('mouseleave', () => {
                img.style.transformOrigin = 'center center';
                img.style.transform = 'scale(1)';
            });
        });

// ======== Modal System Start =======
const kraftOpenModal = (modal) => {
  if (!modal || modal.classList.contains('active')) return;

  modal.classList.add('active');
  document.body.classList.add('modal-open');
  document.documentElement.classList.add('modal-open');

  if (modal.id) {
    window.dispatchEvent(new CustomEvent('modal:opened', { detail: { modalId: modal.id } }));
  }
};

const kraftCloseModal = (modal) => {
  if (!modal || !modal.classList.contains('active')) return;

  modal.classList.remove('active');
  document.body.classList.remove('modal-open');
  document.documentElement.classList.remove('modal-open');
};

window.kraftOpenModalById = (id) => {
  const modal = typeof id === 'string' ? document.getElementById(id) : id;
  if (modal) kraftOpenModal(modal);
};

// Deep link for emails and ads: ?hold=1 opens the private-booking modal on
// its hold-a-date pane (the pane's default tab) as soon as the page settles,
// instead of hoping the visitor finds the button. The param is ignored on
// pages that don't render the modal.
//
// The hold form reads the class off the button that was clicked
// (data-prefill-workshop, via window.__khTrigger). Opened from a link there is
// no button, so EVERY hold arriving from a campaign reached the engine with no
// class on it and was filed as "class to be decided". So carry one: from the
// URL when the campaign names it (?hold=1&workshop=...), otherwise from the
// page's own private-booking button, which on a class page already says it.
(function () {
  var qs;
  try {
    qs = new URLSearchParams(window.location.search);
    if (qs.get('hold') !== '1') return;
  } catch (e) { return; }
  var openHold = function () {
    var m = document.getElementById('kraft-private-booking-modal');
    if (!m) return;
    var named = (qs.get('workshop') || '').trim();
    if (!named) {
      /* Borrow the page's own class ONLY when the page is about one class. A
         class page's buttons all name the same one; a landing page lists a
         dozen, and taking the first would put an arbitrary class on someone's
         private event. Ambiguity means we say nothing and the engine files it
         as "to be decided", which is at least true. */
      var seen = {}, only = '', n = 0;
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-modal-trigger][data-prefill-workshop]'),
        function (b) {
          var w = (b.getAttribute('data-prefill-workshop') || '').trim();
          if (w && !seen[w]) { seen[w] = 1; only = w; n++; }
        });
      if (n === 1) named = only;
    }
    /* A detached span, not the real button: it carries the class and nothing
       else, so the location/listing/mode reads fall back to the page exactly
       as they do when no button was clicked at all. */
    /* The modal now opens on "Send me a quote", which is right for someone
       arriving with a headcount and no date. This link is the other case: it
       exists so a campaign can say "hold your date", so it asks for the
       calendar explicitly rather than inheriting the general default. */
    if (!window.__khTrigger) {
      var ghost = document.createElement('span');
      if (named) ghost.setAttribute('data-prefill-workshop', named);
      ghost.setAttribute('data-kh-mode', 'hold');
      window.__khTrigger = ghost;
    }
    kraftOpenModal(m);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(openHold, 400); });
  } else {
    setTimeout(openHold, 400);
  }
})();

window.kraftCloseModalById = (id) => {
  const modal = typeof id === 'string' ? document.getElementById(id) : id;
  if (modal) kraftCloseModal(modal);
};

document.addEventListener("DOMContentLoaded", () => {
  const openModal = kraftOpenModal;
  const closeModal = kraftCloseModal;

  // Generic modal handler for all modals (capture phase so first click opens modal)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-trigger]');
    if (trigger) {
      // Capture scroll position before anything else so href="#" cannot reset it
      const savedScrollX = window.scrollX;
      const savedScrollY = window.scrollY;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Restore immediately in case the browser already queued a scroll
      window.scrollTo(savedScrollX, savedScrollY);
      const modalId = trigger.getAttribute('data-modal-trigger');
      const modal = document.getElementById(modalId);
      if (modal) {
        // Stash the trigger BEFORE opening: this handler runs first in the
        // capture phase and calls stopImmediatePropagation(), so the
        // per-modal document listeners registered later (global/private
        // modal prefill) never see this click. They read this global as
        // their fallback for data-prefill-* / data-lock-* attributes.
        window.__kraftLastModalTrigger = trigger;
        openModal(modal);
        // Apply trigger image for private booking modal (capture phase runs first, so do it here)
        if (modalId === 'kraft-private-booking-modal') {
          const triggerImage = trigger.getAttribute('data-modal-image');
          const leftArea = document.getElementById('private-booking-modal-left-area');
          if (triggerImage && leftArea) {
            const img = leftArea.querySelector('img');
            if (img) {
              img.removeAttribute('srcset');
              img.src = triggerImage;
            }
            const leftText = document.getElementById('private-booking-modal-left-text');
            if (leftText) {
              const triggerText = trigger.getAttribute('data-modal-image-text');
              leftText.textContent = triggerText || '';
              leftText.style.display = triggerText ? '' : 'none';
            }
          }
        }
      } else {
        console.error('Modal not found with ID:', modalId);
      }
      return;
    }
    
    // Also handle workshop modal trigger class
    const workshopTrigger = e.target.closest('.workshop-modal-trigger');
    if (workshopTrigger) {
      const savedScrollX = window.scrollX;
      const savedScrollY = window.scrollY;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.scrollTo(savedScrollX, savedScrollY);
      const modal = document.getElementById('kraft-workshop-finder-modal');
      if (modal) {
        openModal(modal);
      }
    }
  }, true);

  // Close modal handlers
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const modalId = closeBtn.getAttribute('data-modal-close');
      const modal = document.getElementById(modalId);
      if (modal) {
        closeModal(modal);
      }
    }
  });

  // Close on overlay click
  // Perf: delegated to document (instead of binding each .kraft-modal at
  // DOMContentLoaded) so modals materialized later from <template> elements
  // get overlay-close behavior too.
  document.addEventListener('click', (e) => {
    const modal = e.target.closest('.kraft-modal');
    if (!modal) return;
    // Check for variant modal container
    const variantContainer = modal.querySelector('.variant-modal-container');
    const modalBox = modal.querySelector('.kraft-modal-box');

    // For variant modals, check variant-modal-container
    if (variantContainer) {
      if (!variantContainer.contains(e.target)) {
        closeModal(modal);
      }
    }
    // For regular modals, check kraft-modal-box
    else if (modalBox && !modalBox.contains(e.target)) {
      closeModal(modal);
    }
  });
});

// ======== Workshop Finder Modal Start =======
document.addEventListener("DOMContentLoaded", () => {
  const workshopModal = document.getElementById('kraft-workshop-finder-modal');
  if (!workshopModal) return;

  const locationOptions = workshopModal.querySelectorAll('[data-location]');

  // Handle location selection
  locationOptions.forEach(option => {
    option.addEventListener('click', () => {
      const selectedLocation = option.getAttribute('data-location');
      const locationLink = option.getAttribute('data-location-link');
      
      // If location has a link, navigate to it
      if (locationLink) {
        // Store location name in sessionStorage for header detection
        if (selectedLocation) {
          sessionStorage.setItem('selectedLocation', selectedLocation);
        }
        window.location.href = locationLink;
      } else {
        // Otherwise, just close the modal
        workshopModal.classList.remove('active');
        document.body.classList.remove('modal-open');
        document.documentElement.classList.remove('modal-open');
      }
    });
  });

  // Handle "Prove It" toggle for reviews
  const proveLinks = workshopModal.querySelectorAll('[data-toggle-reviews]');
  const imageContent = workshopModal.querySelector('[data-content-type="image"]');
  const reviewsContent = workshopModal.querySelector('[data-content-type="reviews"]');
  
  proveLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (imageContent && reviewsContent) {
        // Toggle visibility
        if (imageContent.style.display === 'none') {
          // Show image, hide reviews
          imageContent.style.display = '';
          reviewsContent.style.display = 'none';
        } else {
          // Hide image, show reviews
          imageContent.style.display = 'none';
          reviewsContent.style.display = '';
        }
      }
    });
  });
});
// ======== Workshop Finder Modal End =======

// ======== Modal image from trigger (no JS prefill; location/workshop from Liquid) =======
document.addEventListener("DOMContentLoaded", () => {
  // Global Modal - apply trigger image only
  const globalModal = document.getElementById('kraft-global-modal');
  if (globalModal) {
    let lastTrigger = null;
    const _globalLeftArea = document.getElementById('global-modal-left-area');
    const _globalLeftText = document.getElementById('global-modal-left-text');
    let _globalDefaultImgSrc = '';
    let _globalDefaultText = '';
    if (_globalLeftArea) {
      var _gImg = _globalLeftArea.querySelector('img');
      if (_gImg) _globalDefaultImgSrc = _gImg.src;
      if (_globalLeftText) _globalDefaultText = _globalLeftText.textContent || '';
    }

    function _applyGlobalModalImage(trigger) {
      var triggerImage = trigger ? trigger.getAttribute('data-modal-image') : null;
      if (triggerImage && typeof triggerImage === 'string') triggerImage = triggerImage.trim();
      if (triggerImage && _globalLeftArea) {
        var img = _globalLeftArea.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = triggerImage; }
        if (_globalLeftText) {
          var triggerText = trigger.getAttribute('data-modal-image-text');
          _globalLeftText.textContent = triggerText || '';
          _globalLeftText.style.display = triggerText ? '' : 'none';
        }
        return true;
      }
      return false;
    }

    function _resetGlobalModalImage() {
      if (!_globalLeftArea || !_globalDefaultImgSrc) return;
      var img = _globalLeftArea.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = _globalDefaultImgSrc; }
      if (_globalLeftText) {
        _globalLeftText.textContent = _globalDefaultText;
        _globalLeftText.style.display = _globalDefaultText ? '' : 'none';
      }
    }

    function _resolveFinancialDistrictLocation(trigger, rawValue) {
      var path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
      var workshop = (trigger && trigger.getAttribute('data-prefill-workshop') ? trigger.getAttribute('data-prefill-workshop') : '').toLowerCase();
      var scope = (path + ' ' + workshop + ' ' + (rawValue || '').toLowerCase()).trim();

      // Disambiguate FiDi based on page/workshop context.
      if (
        scope.indexOf('/sf') !== -1 ||
        scope.indexOf('san francisco') !== -1 ||
        scope.indexOf('bay area') !== -1 ||
        scope.indexOf('soma') !== -1 ||
        scope.indexOf('san jose') !== -1
      ) {
        return 'San Francisco';
      }
      if (
        scope.indexOf('/nyc') !== -1 ||
        scope.indexOf('new york') !== -1 ||
        scope.indexOf('midtown') !== -1
      ) {
        return 'New York';
      }
      return '';
    }

    function _mapPrefillToDropdownValue(val, trigger) {
      if (!val || typeof val !== 'string') return '';
      var t = val.trim();
      var lower = t.toLowerCase();

      if (lower === 'financial district' || lower === 'fidi') {
        var resolvedFidi = _resolveFinancialDistrictLocation(trigger, t);
        return resolvedFidi || t;
      }

      var map = {
        'midtown': 'New York',
        'bay area': 'San Francisco',
        'irvine, ca': 'Irvine',
        'hawaii': 'Honolulu, Hawaii'
      };
      return map[lower] || t;
    }

    function _applyLocationPrefillAndLock(trigger) {
      var prefill = (trigger.getAttribute('data-prefill-location') || '').trim();
      if (!prefill) return;
      var locationValue = _mapPrefillToDropdownValue(prefill, trigger);
      var lock = trigger.getAttribute('data-lock-location') === 'true' || trigger.getAttribute('data-lock-fields') === 'true';
      var selects = globalModal.querySelectorAll('#kraft-modal-location-select, #kraft-modal-location-select-alt');
      var locationLower = locationValue.toLowerCase();
      selects.forEach(function(sel) {
        if (!sel || !sel.options) return;
        var options = Array.from(sel.options);
        var opt = options.find(function(o) { return o.value && o.value.toLowerCase().trim() === locationLower; }) ||
                  options.find(function(o) { return o.value && (o.value.toLowerCase().indexOf(locationLower) !== -1 || locationLower.indexOf(o.value.toLowerCase()) !== -1); });
        if (opt && opt.value) {
          sel.value = opt.value;
          if (lock) {
            sel.disabled = true;
            sel.style.backgroundColor = '#f5f5f5';
            sel.style.cursor = 'not-allowed';
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = sel.name;
            hidden.value = sel.value;
            hidden.setAttribute('data-locked-location-field', 'true');
            sel.parentNode.appendChild(hidden);
          }
        }
      });
    }

    function _clearLocationLock() {
      globalModal.querySelectorAll('#kraft-modal-location-select, #kraft-modal-location-select-alt').forEach(function(sel) {
        sel.disabled = false;
        sel.style.backgroundColor = '';
        sel.style.cursor = '';
      });
      globalModal.querySelectorAll('input[data-locked-location-field="true"]').forEach(function(el) { el.remove(); });
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger="kraft-global-modal"]');
      if (trigger) lastTrigger = trigger;
    }, true);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Fall back to the trigger stashed by the generic open handler —
          // its stopImmediatePropagation() starves this block's own click
          // listener, so lastTrigger is usually null here.
          const gmTrigger = lastTrigger || window.__kraftLastModalTrigger || null;
          if (globalModal.classList.contains('active') && gmTrigger) {
            _applyGlobalModalImage(gmTrigger);
            _applyLocationPrefillAndLock(gmTrigger);
            lastTrigger = null;
            window.__kraftLastModalTrigger = null; // consume so a later programmatic open can't reuse a stale trigger
          }
        }
      });
    });
    observer.observe(globalModal, { attributes: true, attributeFilter: ['class'] });

    globalModal.querySelectorAll('[data-modal-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        _clearLocationLock();
        _resetGlobalModalImage();
      });
    });
  }

  // Private Booking Modal - apply trigger image or context-aware image only
  const privateModal = document.getElementById('kraft-private-booking-modal');
  if (privateModal) {
    let lastTrigger = null;

    // --- Context-aware image helpers ---
    // Keys: terrarium | mosaic | tufting | moss | birthday | team_building | default
    let _privateImageMap = null;
    const _privateLeftArea = document.getElementById('private-booking-modal-left-area');
    const _privateLeftText = document.getElementById('private-booking-modal-left-text');

    function _loadPrivateImageMap() {
      if (_privateImageMap) return _privateImageMap;
      const el = document.getElementById('private-booking-modal-image-map');
      if (el) {
        try { _privateImageMap = JSON.parse(el.textContent); } catch (e) {}
      }
      return _privateImageMap;
    }

    function _normalizeWorkshopKey(workshop) {
      if (!workshop) return 'default';
      const w = workshop.toLowerCase();
      if (w.includes('terrarium')) return 'terrarium';
      if (w.includes('mosaic') || w.includes('turkish')) return 'mosaic';
      if (w.includes('tufting')) return 'tufting';
      if (w.includes('moss')) return 'moss';
      if (w.includes('birthday') || w.includes('keiki')) return 'birthday';
      if (w.includes('team') && w.includes('build')) return 'team_building';
      return 'default';
    }

    function _applyPrivateBookingImage(workshop) {
      const map = _loadPrivateImageMap();
      if (!map || !_privateLeftArea) return;
      const key = _normalizeWorkshopKey(workshop);
      const entry = (map[key] && map[key].url) ? map[key] : map['default'];
      if (!entry || !entry.url) return;
      const img = _privateLeftArea.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = entry.url; }
      if (_privateLeftText) {
        _privateLeftText.textContent = entry.text || '';
        _privateLeftText.style.display = entry.text ? '' : 'none';
      }
    }

    function _resetPrivateBookingImage() {
      const map = _loadPrivateImageMap();
      if (!map || !_privateLeftArea) return;
      const entry = map['default'];
      if (!entry || !entry.url) return;
      const img = _privateLeftArea.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = entry.url; }
      if (_privateLeftText) {
        _privateLeftText.textContent = entry.text || '';
        _privateLeftText.style.display = entry.text ? '' : 'none';
      }
    }
    // --- End context-aware image helpers ---

    // --- Occasion chips (Aug 2026): replace the free-text occasion field.
    // A chip click writes its label into the hidden name="workshop" input
    // (Formspark payload unchanged). The PHOTO stays as-is — only the
    // support text over it changes, using the occasion→image map's text
    // when configured in theme settings, else the fallback lines below.
    // Clicking the selected chip again deselects (the field is optional).
    var OCCASION_SUPPORT_TEXT = {
      'Team building': 'Team offsites & remote socials',
      'Birthday': 'Everyone keeps what they make',
      'Date night': 'Two kits, one artist',
      'Just for fun': 'No occasion needed'
    };
    var _occBaseText = null; // caption as it was before the first chip click

    function _applyOccasionSupportText(occasion) {
      if (!_privateLeftText) return;
      if (_occBaseText === null) {
        _occBaseText = { text: _privateLeftText.textContent, display: _privateLeftText.style.display };
      }
      var map = _loadPrivateImageMap();
      var key = _normalizeWorkshopKey(occasion);
      var mapText = map && map[key] && key !== 'default' ? map[key].text : '';
      var text = mapText || OCCASION_SUPPORT_TEXT[occasion] || '';
      if (!text) return;
      _privateLeftText.textContent = text;
      _privateLeftText.style.display = '';
    }

    function _restoreOccasionSupportText() {
      if (!_privateLeftText || _occBaseText === null) return;
      _privateLeftText.textContent = _occBaseText.text;
      _privateLeftText.style.display = _occBaseText.display;
    }

    privateModal.addEventListener('click', function (e) {
      var chip = e.target.closest('.kraft-occasion-chip');
      if (!chip) return;
      var picker = chip.closest('[data-occasion-picker]');
      if (!picker) return;
      var hidden = picker.querySelector('input[name="workshop"]');
      var wasSelected = chip.classList.contains('is-selected');
      picker.querySelectorAll('.kraft-occasion-chip').forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      if (wasSelected) {
        if (hidden) hidden.value = '';
        _restoreOccasionSupportText();
      } else {
        chip.classList.add('is-selected');
        chip.setAttribute('aria-pressed', 'true');
        if (hidden) hidden.value = chip.getAttribute('data-occasion') || '';
        _applyOccasionSupportText(chip.getAttribute('data-occasion') || '');
      }
    });

    function _clearOccasionChips() {
      privateModal.querySelectorAll('[data-occasion-picker]').forEach(function (picker) {
        picker.querySelectorAll('.kraft-occasion-chip.is-selected').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        var hidden = picker.querySelector('input[name="workshop"]');
        if (hidden) hidden.value = '';
      });
      _restoreOccasionSupportText();
      _occBaseText = null; // re-capture on next open (trigger may set a new caption)
    }
    // Clear chips when the form resets (successful submit) — the hidden
    // input resets to value="" on its own; the chip styling must follow.
    privateModal.querySelectorAll('form').forEach(function (fm) {
      fm.addEventListener('reset', function () { setTimeout(_clearOccasionChips, 0); });
    });
    // --- End occasion chips ---

    function _applyTriggerImage(trigger) {
      var triggerImage = trigger ? trigger.getAttribute('data-modal-image') : null;
      if (triggerImage && typeof triggerImage === 'string') triggerImage = triggerImage.trim();
      if (triggerImage && _privateLeftArea) {
        var img = _privateLeftArea.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = triggerImage; }
        if (_privateLeftText) {
          var triggerText = trigger.getAttribute('data-modal-image-text');
          _privateLeftText.textContent = triggerText || '';
          _privateLeftText.style.display = triggerText ? '' : 'none';
        }
        return true;
      }
      return false;
    }

    function _resolveFinancialDistrictLocationPrivate(trigger, rawValue) {
      var path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
      var workshop = (trigger && trigger.getAttribute('data-prefill-workshop') ? trigger.getAttribute('data-prefill-workshop') : '').toLowerCase();
      var pageCtx = document.getElementById('kraft-page-location-context');
      var ctxLoc = pageCtx ? (pageCtx.getAttribute('data-location') || '').toLowerCase() : '';
      var scope = (path + ' ' + workshop + ' ' + ctxLoc + ' ' + (rawValue || '').toLowerCase()).trim();

      if (
        scope.indexOf('/sf') !== -1 ||
        scope.indexOf('san francisco') !== -1 ||
        scope.indexOf('bay area') !== -1 ||
        scope.indexOf('soma') !== -1 ||
        scope.indexOf('san jose') !== -1
      ) {
        return 'San Francisco';
      }
      if (
        scope.indexOf('/nyc') !== -1 ||
        scope.indexOf('new york') !== -1 ||
        scope.indexOf('midtown') !== -1
      ) {
        return 'New York';
      }
      return '';
    }

    function _mapPrefillToDropdownValuePrivate(val, trigger) {
      if (!val || typeof val !== 'string') return '';
      var t = val.trim();
      var lower = t.toLowerCase();

      if (lower === 'financial district' || lower === 'fidi') {
        var resolvedFidi = _resolveFinancialDistrictLocationPrivate(trigger, t);
        return resolvedFidi || t;
      }

      var map = {
        'midtown': 'New York',
        'bay area': 'San Francisco',
        'irvine, ca': 'Irvine',
        'hawaii': 'Honolulu, Hawaii'
      };
      return map[lower] || t;
    }

    function _applyPrivateModalLocationPrefillAndLock(trigger) {
      var prefill = (trigger ? trigger.getAttribute('data-prefill-location') : '') || '';
      prefill = (prefill || '').trim();
      if (!prefill) {
        var pageCtx = document.getElementById('kraft-page-location-context');
        if (pageCtx) prefill = (pageCtx.getAttribute('data-location') || '').trim();
      }
      // Virtual pages: even without a trigger attribute or page-context span,
      // the event location is known — preselect Virtual (unlocked, so the
      // visitor can still change it).
      if (!prefill && window.location && (window.location.pathname || '').toLowerCase().indexOf('/virtual') !== -1) {
        prefill = 'Virtual';
      }
      if (!prefill) return;
      var locationValue = _mapPrefillToDropdownValuePrivate(prefill, trigger);
      var lock = (trigger && (trigger.getAttribute('data-lock-location') === 'true' || trigger.getAttribute('data-lock-fields') === 'true')) || !!document.getElementById('kraft-page-location-context');
      var run = function() {
        var selects = privateModal.querySelectorAll('#kraft-private-modal-location-select, #kraft-private-modal-location-select-alt');
        var locationLower = locationValue.toLowerCase();
        selects.forEach(function(sel) {
          if (!sel || !sel.options) return;
          var options = Array.from(sel.options);
          var opt = options.find(function(o) { return o.value && o.value.toLowerCase().trim() === locationLower; }) ||
                    options.find(function(o) { return o.value && (o.value.toLowerCase().indexOf(locationLower) !== -1 || locationLower.indexOf(o.value.toLowerCase()) !== -1); });
          /* Partner studios are not in the theme's location settings, so no
             option matched and the visitor saw an empty "Event Location" on
             that studio's own page — the one place we know the answer. Add the
             location we were given rather than dropping it. Applies to both
             copies of the form (the modal renders one of two). */
          if (!opt && locationValue) {
            opt = document.createElement('option');
            opt.value = locationValue;
            opt.textContent = locationValue;
            var notSure = options.find(function(o) { return (o.value || '').toLowerCase() === 'not sure'; });
            if (notSure) { sel.insertBefore(opt, notSure); } else { sel.appendChild(opt); }
          }
          if (opt && opt.value) {
            sel.value = opt.value;
            if (lock) {
              sel.disabled = true;
              sel.style.backgroundColor = '#f5f5f5';
              sel.style.cursor = 'not-allowed';
              var hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = sel.name;
              hidden.value = sel.value;
              hidden.setAttribute('data-locked-location-field', 'true');
              sel.parentNode.appendChild(hidden);
              /* The class page already names its studio; a greyed-out
                 select repeating it is one more field to read, not answer.
                 The hidden input above still submits the value. */
              var locRow = sel.closest('.mb-2');
              if (locRow) locRow.style.display = 'none';
            }
          }
        });
      };
      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(function() { run(); });
      } else {
        setTimeout(run, 50);
      }
    }

    function _clearPrivateModalLocationLock() {
      privateModal.querySelectorAll('#kraft-private-modal-location-select, #kraft-private-modal-location-select-alt').forEach(function(sel) {
        sel.disabled = false;
        sel.style.backgroundColor = '';
        sel.style.cursor = '';
      });
      privateModal.querySelectorAll('input[data-locked-location-field="true"]').forEach(function(el) { el.remove(); });
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger="kraft-private-booking-modal"]');
      if (trigger) lastTrigger = trigger;
    }, true);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (privateModal.classList.contains('active')) {
            // Fall back to the trigger stashed by the generic open handler —
            // its stopImmediatePropagation() starves this block's own click
            // listener, so lastTrigger is usually null here.
            const pmTrigger = lastTrigger || window.__kraftLastModalTrigger || null;
            if (pmTrigger) {
              if (!_applyTriggerImage(pmTrigger)) {
                _applyPrivateBookingImage(pmTrigger.getAttribute('data-prefill-workshop') || '');
              }
            }
            _applyPrivateModalLocationPrefillAndLock(pmTrigger);
            lastTrigger = null;
            window.__kraftLastModalTrigger = null; // consume so a later programmatic open can't reuse a stale trigger
          }
        }
      });
    });
    observer.observe(privateModal, { attributes: true, attributeFilter: ['class'] });

    privateModal.querySelectorAll('[data-modal-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        _clearPrivateModalLocationLock();
        _resetPrivateBookingImage();
        _clearOccasionChips();
      });
    });
  }

});
// ======== Modal image-from-trigger End =======
// ======== Modal System End =======
// ======== Cart Drawer Trigger =======
document.addEventListener("DOMContentLoaded", () => {
  // Handle all cart icon clicks (mobile + nav) to open cart drawer
  const cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  cartTriggers.forEach((cartTrigger) => {
    cartTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.dispatchEvent(new CustomEvent('open'));
        }
      }
    });
  });
});
// ======== Cart Drawer Trigger End =======

// ======== Video Preview Play Button =======
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const playButton = e.target.closest('[data-video-trigger]');
    if (playButton) {
      e.preventDefault();
      
      const videoUrl = playButton.getAttribute('data-video-url');
      const videoType = playButton.getAttribute('data-video-type') || 'youtube';
      const thumbnailWrapper = playButton.closest('.video-preview-thumbnail-wrapper');
      const thumbnail = playButton.closest('.video-preview-thumbnail');
      
      if (!videoUrl || !thumbnail) return;
      
      // Hide play button
      playButton.style.display = 'none';
      
      // Hide thumbnail image
      const thumbnailImg = thumbnail.querySelector('img');
      if (thumbnailImg) {
        thumbnailImg.style.display = 'none';
      }
      
      // Create video iframe
      let iframeSrc = '';
      
      if (videoType === 'youtube') {
        // Extract YouTube video ID
        let videoId = '';
        const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
        const match = videoUrl.match(youtubeRegex);
        if (match) {
          videoId = match[1];
        } else {
          // Try to extract from URL directly
          const urlParams = new URLSearchParams(videoUrl.split('?')[1]);
          videoId = urlParams.get('v') || videoUrl.split('/').pop().split('?')[0];
        }
        iframeSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      } else if (videoType === 'vimeo') {
        // Extract Vimeo video ID
        const vimeoRegex = /(?:vimeo\.com\/)(\d+)/;
        const match = videoUrl.match(vimeoRegex);
        const videoId = match ? match[1] : videoUrl.split('/').pop();
        iframeSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      } else if (videoType === 'direct') {
        // Direct video - create video element instead
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        thumbnail.appendChild(video);
        return;
      }
      
      // Create and insert iframe
      if (iframeSrc) {
        const iframe = document.createElement('iframe');
        iframe.src = iframeSrc;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.border = 'none';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');
        
        thumbnail.appendChild(iframe);
      }
    }
  });
});
// ======== Video Preview Play Button End =======

// ======== Contact Modal with Location Info ========
document.addEventListener('DOMContentLoaded', () => {
  const contactModal = document.getElementById('kraft-contact-modal');
  if (!contactModal) return;

  // --- Per-section modal image override (capture phase, before modal opens) ---
  const contactLeftArea = document.getElementById('contact-modal-left-area');

  function applyContactImage(imageUrl, imageText) {
    if (!contactLeftArea) return;
    const img = contactLeftArea.querySelector('.kraft-contact-modal-img');
    const textEl = document.getElementById('contact-modal-left-text');
    if (img) {
      img.src = imageUrl || '';
      img.removeAttribute('srcset');
      img.style.display = imageUrl ? '' : 'none';
    }
    if (textEl) {
      textEl.textContent = imageText || '';
      textEl.style.display = imageText ? '' : 'none';
    }
    contactLeftArea.classList.toggle('kraft-modal-left-area--empty', !imageUrl);
  }

  function resetContactImage() {
    const defaultImage = contactModal.getAttribute('data-contact-default-image') || '';
    const defaultText = contactModal.getAttribute('data-contact-default-image-text') || '';
    applyContactImage(defaultImage, defaultText);
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-modal-trigger="kraft-contact-modal"]');
    if (!trigger) return;
    const defaultImage = contactModal.getAttribute('data-contact-default-image') || '';
    const defaultText = contactModal.getAttribute('data-contact-default-image-text') || '';
    const triggerImageRaw = trigger.getAttribute('data-modal-image');
    const triggerImage = triggerImageRaw ? triggerImageRaw.trim() : '';
    const triggerText = trigger.getAttribute('data-modal-image-text');
    const imageUrl = triggerImage || defaultImage;
    const imageText = triggerImage ? (triggerText || '') : defaultText;
    applyContactImage(imageUrl, imageText);
  }, true);

  const contactObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class' && !contactModal.classList.contains('active')) {
        resetContactImage();
      }
    });
  });
  contactObserver.observe(contactModal, { attributes: true, attributeFilter: ['class'] });

  // Listen for contact modal trigger clicks
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-trigger="kraft-contact-modal"]');
    if (!trigger) return;

    e.preventDefault();

    // Get contact data from button attributes
    const locationName = trigger.getAttribute('data-location') || 'Get in Touch';
    const address = trigger.getAttribute('data-contact-address') || '';
    const phone = trigger.getAttribute('data-contact-phone') || '(650) 460-2411';
    const email = trigger.getAttribute('data-contact-email') || 'info@kraftstories.com';
    const hours = trigger.getAttribute('data-contact-hours') || 'Mon-Fri: 9AM-6PM\nSat-Sun: 10AM-5PM';
    const prefillSubject = trigger.getAttribute('data-prefill-workshop') || trigger.getAttribute('data-prefill-subject') || '';

    // Small delay to ensure modal is opened first
    setTimeout(() => {
      // Prefill subject (e.g. "Maker Kids Studio - Parent Call")
      const subjectInput = contactModal.querySelector('input[name="subject"]');
      if (subjectInput && prefillSubject) {
        subjectInput.value = prefillSubject;
      }

      // Update location name
      const locationNameEl = contactModal.querySelector('.kraft-modal-contact-location-name');
      if (locationNameEl) {
        locationNameEl.textContent = locationName;
      }

      // Update address (show/hide based on presence)
      const addressItem = contactModal.querySelector('[data-contact-type="address"]');
      const addressValue = contactModal.querySelector('[data-contact-address]');
      if (address && address.trim() !== '') {
        if (addressItem) addressItem.style.display = 'flex';
        if (addressValue) addressValue.textContent = address;
      } else {
        if (addressItem) addressItem.style.display = 'none';
      }

      // Update phone
      const phoneValue = contactModal.querySelector('[data-contact-phone]');
      if (phoneValue) phoneValue.textContent = phone;

      // Update email
      const emailValue = contactModal.querySelector('[data-contact-email]');
      if (emailValue) emailValue.textContent = email;

      // Update hours (convert \n to <br>)
      const hoursValue = contactModal.querySelector('[data-contact-hours]');
      if (hoursValue) {
        hoursValue.innerHTML = hours.replace(/\\n/g, '<br>').replace(/\n/g, '<br>');
      }
    }, 50);
  });
});
// ======== Contact Modal End ========


/* === Modal CTA arrow guard (Aug 2026): modal-form-handler.js swaps the
   submit button's innerHTML for its loading spinner and restores plain
   text afterwards, which would drop the jx-btn arrow. Restore it. === */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.kraft-modal .kraft-modal-submit-wrap .kraft-modal-submit-btn').forEach(function (sb) {
    if (sb.dataset.kraftArrowGuard) return;
    sb.dataset.kraftArrowGuard = '1';
    var orig = sb.innerHTML;
    new MutationObserver(function () {
      if (!sb.disabled && !sb.querySelector('.jx-btn-arrow')) sb.innerHTML = orig;
    }).observe(sb, { childList: true, attributes: true });
  });
});
